module.exports = __webpack_public_path__ + "img/bgimg.226bf20c.jpg";